import React, { useState } from 'react';
import Dropzone from 'react-dropzone';
import axios from 'axios';
import presignS3 from '../../../utils/s3Presign';
import { PropTypes } from 'prop-types';
import Swiper from 'react-id-swiper';
import addEditMamObject from '../../../api/graphql/mutations/addEditMamObject';
import MamObjectFormMultiple from './MamObjectFormMultiple';
import Modal from '../../Modal/Modal';
import checkFileType from '../../../utils/checkFileType';


const uploaderCopy = {
  single: 'Drop a file here, or click to select a file',
  multiple: 'Drop some files here, or click to select files',
};

const UploaderMultiple = ({ multiple, addImages, handleMoreItems }) => {
  const initialImageState = {
    assetSlugName: '',
    filename: '',
    fileExtension: '',
    url: '',
    fileReadableName: {
      en: '',
      es: '',
      ca: '',
      pt: '',
    },
    description: {
      en: '',
      es: '',
      ca: '',
      pt: '',
    },
    type: '',
    tags: [],
    isPublic: false,
  };

  const initialState = {
    images: [],
  };

  const [uploading, setUploading] = useState(false);
  const [state, setState] = useState(initialState);
  const [showForm, setShowForm] = useState(false);
  const [canEditMultiple, setCanEditMultiple] = useState(true);

  const inputObjHandler = (e, index) => {
    const { images } = state;
    const current = images[index];
    const { value, lang, name } = e.target;
    const data = {
      ...current,
      [name]: {
        ...current[name],
        [lang]: value,
      },
    };
    const newState = { ...state };
    newState.images[index] = data;
    setState(newState);
  };

  const inputObjHandlerMultiple = (e) => {
    const { images } = state;
    const { value, lang, name } = e.target;

    const modifiedImages = images.map((image) => {
      const newImage = { ...image };
      newImage.description = {
        ...image.description,
        [lang]: value,
      };
      return newImage;
    });

    setState({ images: modifiedImages });
  };

  const makePublicHandlerMultiple = (bool) => {
    const { images } = state;
    const modifiedImages = images.map((image) => {
      const newImage = { ...image };
      newImage.isPublic = bool;
      return newImage;
    });

    setState({ images: modifiedImages });
  };

  const makePublicHandler = (bool, index) => {
    const { images } = state;
    const current = images[index];
    const data = {
      ...current,
      isPublic: bool,
    };
    const newState = { ...state };
    newState.images[index] = data;
    setState(newState);
  };

  const handleClick = () => {
    setShowForm(!showForm);
  };

  const saveObject = obj => addEditMamObject(obj)
    .catch(err => console.log(err));

  const saveAllObjects = () => {
    if (state.images && state.images.length) {
      state.images.map(assetObject => saveObject(assetObject));
      setShowForm(false);
    }
  };

  const handleTagsMultiple = (name) => {
    const { images } = state;
    const tagsarr = images[0].tags;
    const indexOfTag = images[0].tags.indexOf(name);
    if (indexOfTag < 0) {
      tagsarr.push(name);
    } else {
      tagsarr.splice(indexOfTag, 1);
    }
    const modifiedImages = images.map((image) => {
      const newImage = { ...image };
      newImage.tags = tagsarr;
      return newImage;
    });

    setState({ images: modifiedImages });
  };

  const handleTags = (name, index) => {
    const { images } = state;
    const current = images[index];
    const tagsarr = [...current.tags];
    const indexOfTag = tagsarr.indexOf(name);
    if (indexOfTag < 0) {
      tagsarr.push(name);
    } else {
      tagsarr.splice(indexOfTag, 1);
    }
    const data = {
      ...current,
      tags: tagsarr,
    };
    const newState = { ...state };
    newState.images[index] = data;
    setState(newState);
  };

  const handleDrop = (files) => {
    setUploading(true);
    const uploadedImages = [];
    // route where file will be uploaded, the route will be the same fot all files
    const uploaders = files.map((file) => {
      // generate a random name for the file
      // eslint-disable-next-line no-bitwise
      const randomFileName = [...Array(20)].map(() => (~~(Math.random() * 36)).toString(36)).join('');
      const fileExtension = file.name.split('.').pop();
      const filename = `${randomFileName}_${Date.now().toString()}`;
      const filenameWithExtension = `${filename}.${fileExtension}`;
      const url = `https://assets.primaverasound.com/psweb/${filenameWithExtension}`;

      // if (fileExtension === 'jpeg') return setError('You can only images in .PNG or .JPG formats');

      return presignS3({
        fileName: filenameWithExtension,
        fileType: file.type,
        type: 'upload',
      })
        .then(async (result) => {
          const assetObject = {
            ...initialImageState,
            assetSlugName: filename,
            fileReadableName: {
              en: file.name.substring(0, file.name.lastIndexOf('.')) || file.name,
            },
            filename,
            fileExtension,
            url,
            type: checkFileType(fileExtension),
            fileSize: file.size,
          };
          uploadedImages.push(assetObject);
          const signedUrl = result.data;
          const options = {
            headers: {
              'Content-Type': file.type,
            },
            crossDomain: true,
          };
          await axios.put(signedUrl, file, options);
          await saveObject(assetObject);
        })
        .catch((err) => {
          console.log(err);
        });
    });

    axios.all(uploaders).then(() => {
      setState({ images: uploadedImages });
      setUploading(false);
      setShowForm(true);
      handleMoreItems(uploadedImages);
    });
  };

  // Settings for Swiper

  const params = {
    slidesPerView: 1,
    centerSlides: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  };


  // const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, multiple });
  return (
    <>
      {showForm && state.images
      && (
      <Modal title={`Edit ${state.images.length} files`} handleClick={handleClick} type="display" close={handleClick}>
        <>
          {!canEditMultiple
            ? (
              <Swiper {...params}>
                {
              state.images.map((image, index) => (
                <div key={image.assetSlugName} className="w-auto" style={{ maxWidth: '100%' }}>
                  <MamObjectFormMultiple inputObjHandlerMultiple={inputObjHandlerMultiple} canEditMultiple={canEditMultiple} objState={image} makePublicHandler={makePublicHandler} inputObjHandler={inputObjHandler} close={handleClick} toggleTag={handleTags} index={index} />
                </div>
              ))
            }
              </Swiper>
            )
            : (
              <div className="w-auto" style={{ maxWidth: '100%' }}>
                <MamObjectFormMultiple imgCount={state.images ? state.images.length : 0} toggleTagMultiple={handleTagsMultiple} inputObjHandlerMultiple={inputObjHandlerMultiple} canEditMultiple={canEditMultiple} objState={state.images && state.images.length ? state.images[0] : {}} makePublicHandlerMultiple={makePublicHandlerMultiple} inputObjHandler={inputObjHandler} close={handleClick} />
              </div>
            )
  }
          {canEditMultiple ? (
            <div className="swiper-pagination swiper-pagination-fraction text-grey">
              <span className="swiper-pagination-current">1</span>
              {' '}
/
              {' '}
              <span className="swiper-pagination-total">
                {state.images.length}
              </span>
            </div>
          ) : null}
          <div className="flex justify-between items-center pb-4">
            <button className={`font-americaMonoBold text-xs px-6 py-2 rounded-full border-white border-1 ${canEditMultiple ? 'bg-white text-black' : 'bg-black text-white'} uppercase mt-2 w-110px`} onClick={() => { setCanEditMultiple(!canEditMultiple); }} type="button">All</button>
            <div className="flex flex-row justify-end">
              <button className="font-americaMonoBold text-xs px-6 py-2 rounded-full border-white border-1 bg-black text-white uppercase ml-7 mt-2 w-110px" onClick={handleClick} type="button">cancel</button>
              <button className="font-americaMonoBold text-xs px-6 py-2 rounded-full bg-white text-black uppercase ml-7 mt-2 w-110px" onClick={saveAllObjects} type="button">save all</button>
            </div>
          </div>
        </>
      </Modal>
      )}
      {/* <div {...getRootProps()} className="flex flex-col items-center justify-center border-dashed border-greyFilter border-2 rounded-lg py-8 my-4 outline-none mx-1">
        <input {...getInputProps()} />
        <p className="text-sm font-americaMonoRegular uppercase cursor-default">{multiple ? uploaderCopy.multiple : uploaderCopy.single}</p>
        <span className="font-icon text-greyFilter text-4xl icon-add-image3 py-4" />
        <p className="text-sm font-americaMonoRegular uppercase border-1 border-black rounded-full px-5 py-1 cursor-default mb-4">Browse files</p>

        {uploading && <p className="font-americaMonoRegular uppercase"> Uploading file... </p>}
      </div> */}
      <Dropzone onDrop={handleDrop} multiple>
        {({ getRootProps, getInputProps }) => (
          <div {...getRootProps()} className="flex flex-col items-center justify-center border-dashed border-greyFilter border-2 rounded-lg py-8 my-4 outline-none mx-1">
            <input {...getInputProps()} />
            <p className="text-sm font-americaMonoRegular uppercase cursor-default">{multiple ? uploaderCopy.multiple : uploaderCopy.single}</p>
            <span className="font-icon text-greyFilter text-4xl icon-add-image3 py-4" />
            <p className="text-sm font-americaMonoRegular uppercase border-1 border-black rounded-full px-5 py-1 cursor-default mb-4">Browse files</p>

            {uploading && <p className="font-americaMonoRegular uppercase"> Uploading files... </p>}
          </div>
        )}
      </Dropzone>
    </>
  );
};

UploaderMultiple.propTypes = {
  multiple: PropTypes.bool,
};

UploaderMultiple.defaultProps = {
  multiple: false,
};

export default UploaderMultiple;
